import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Phone, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function DoctorChats() {
    const [consults, setConsults] = useState([]);
    useEffect(() => {
        api.get("/consultations").then((r) => setConsults(r.data));
    }, []);
    return (
        <div className="pb-16">
            <div className="border-b border-veda-border">
                <div className="veda-container py-8 md:py-12">
                    <Link
                        to="/doctor/dashboard"
                        className="inline-flex items-center gap-1 text-xs font-medium text-veda-muted"
                    >
                        <ArrowLeft size={14} /> Dashboard
                    </Link>
                    <h1 className="font-display mt-3 text-4xl text-veda-onSurface md:text-5xl">
                        Patient chats
                    </h1>
                </div>
            </div>
            {consults.length === 0 ? (
                <p className="veda-container py-16 text-center text-sm text-veda-muted">
                    No consultations yet.
                </p>
            ) : (
                <ul className="veda-container-narrow divide-y divide-veda-divider">
                    {consults.map((c) => (
                        <li key={c.consultation_id}>
                            <Link
                                to={`/consultation/${c.consultation_id}`}
                                className="flex items-center gap-3 py-4"
                            >
                                <span className="grid h-10 w-10 place-items-center bg-veda-surface2">
                                    {c.mode === "call" ? (
                                        <Phone size={14} />
                                    ) : (
                                        <MessageCircle size={14} />
                                    )}
                                </span>
                                <div className="min-w-0 flex-1">
                                    <p className="text-sm font-semibold text-veda-onSurface">
                                        {c.customer_name}
                                    </p>
                                    <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-veda-muted">
                                        {c.slot} · {c.mode}
                                    </p>
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
